import { DOCUMENT } from '@angular/common';
import { type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';
import { ClerkCustomerWebService } from './clerk-customer-web.service';

export const customerAuthorizationInterceptor: HttpInterceptorFn = (request, next) => {
  const document: Document = inject(DOCUMENT);
  const url: URL = new URL(request.url, document.location.origin);
  if (url.origin !== document.location.origin || !url.pathname.startsWith('/api/')) {
    return next(request);
  }
  const clerk: ClerkCustomerWebService = inject(ClerkCustomerWebService);
  return from(clerk.getToken()).pipe(switchMap((token: string | null) => next(request.clone({
    headers: token ? request.headers.set('Authorization', `Bearer ${token}`) : request.headers.delete('Authorization'),
  }))));
};
